export default __webpack_public_path__ + "static/media/background.a544fe75.mp4";